import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-horizontal-align-left",
  templateUrl: "./med-icon-horizontal-align-left.component.html",
})
export class MedIconHorizontalAlignLeftComponent extends SvgMixinComponent {}
